// extracted by mini-css-extract-plugin
export default {"menuTab":"styles_menuTab__c7jHf","collapsed":"styles_collapsed__tbHqF","link":"styles_link__5qEyU","icon":"styles_icon__VcPuP","active":"styles_active__xLHlD"};